module.exports = require("react-responsive");


//////////////////
// WEBPACK FOOTER
// external "react-responsive"
// module id = 28
// module chunks = 0